import { Button, DialogActions, DialogTitle } from "@mui/material";
import GTextField from "../../libs/textfield/GTextField";
import usePortfolio from "../../hooks/PortfolioProvider";
import { AccountTypes } from "../../shared/IAccount";
import Dropdown from "../../libs/dropdown/Dropdown";
import { useMemo, useRef } from "react";
import FormGroup from "../../libs/form/FormGroup";
import FormControl from "../../libs/form/FormControl";
import Validators from "../../libs/form/Validators";
import PortAccount from "../../models/PortAccount";
import { useSnackbar } from "../../libs/dialog/SnackbarProvider";
import { useDialog } from "../../libs/dialog/DialogProvider";

export default function EditAccount(props:{account:number}) {
    const {portfolio} = usePortfolio()
    const refName = useRef<any>()
    const refType = useRef<any>()

    const {setSnackbar} = useSnackbar()
    const {closeDialog} = useDialog()

    const form = useMemo(() => {
        return new FormGroup("account", [
            new FormControl("name", [Validators.Required])
        ])
    }, [])
    const account = portfolio.account(props.account)
    const edit = account ? <>
        <GTextField controlName="name" defaultValue={portfolio.accountName(props.account)} floatLabel="Account name" form={form} inputRef={refName}/>
        <Dropdown options={AccountTypes} defaultValue={account.type} label="Account type" ref={refType}/>
    </> : null
    const onSave = async () => {
        form.markAllAsDirty()
        if (!form.valid) return
        try {
            await PortAccount.i.updateAccount(props.account, refName.current.value, refType.current.value)
            closeDialog()
        } catch(e){
            setSnackbar(e)
        }
    }
    return <>
        <DialogTitle>Edit</DialogTitle>
        <div className="content flex vert gap-24">{edit}</div>
        <div>{form.valid}</div>
        <DialogActions>
            <Button onClick={onSave}>Save</Button>
        </DialogActions>
    </>
}